
export class Usuario {
  id_usuarios: number;
  nome: string;
  email: string;
  celular: string;
  data_nascimento: Date;
  administrador: boolean;
  sexo: number;
}
